/**
 * Layout principal da aplicação
 */

import React from 'react';
import { Box, Container } from '@mui/material';
import { Header } from './Header';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  footerType?: 'default' | 'cliente' | 'previsao' | 'pedido';
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  disablePadding?: boolean;
  showPainelPrevisao?: boolean;
  showPainelPedido?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  showHeader = true,
  showFooter = true,
  footerType = 'default',
  maxWidth = 'lg',
  disablePadding = false,
  showPainelPrevisao = false,
  showPainelPedido = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      {showHeader && <Header title={title} />}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: (showPainelPrevisao || showPainelPedido) ? 20 : (showHeader ? 8 : 0),
          pb: showFooter ? 8 : 2,
          overflow: 'auto',
        }}
      >
        {disablePadding ? (
          children
        ) : (
          <Container
            maxWidth={maxWidth}
            sx={{
              py: 2,
              px: { xs: 2, sm: 3 },
            }}
          >
            {children}
          </Container>
        )}
      </Box>

      {showFooter && <Footer tipo={footerType} />}
    </Box>
  );
};

export default Layout;